import * as stylex from "@stylexjs/stylex";
import { useId } from "react";
import { copy } from "@/copy";
import type { WeatherIcon } from "@/domain/schemas";
import "@/theme/seasons.stylex";
import { season } from "@/theme/seasons.stylex";
import "@/theme/tokens.stylex";
import { colors, radii } from "@/theme/tokens.stylex";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
import { Eyebrow } from "@/ui/Eyebrow";
import { Icon } from "@/ui/Icon";
import { weatherIcons } from "@/ui/weatherIcons";
export type PreviewHour = {
  time: string;
  icon: WeatherIcon;
  temp: string;
  label: string;
};
export type PreviewTile = {
  icon: WeatherIcon;
  temp: string;
  condition: string;
  hours: readonly PreviewHour[];
};
export type PreviewPlan = {
  id: string;
  time: string;
  title: string;
  who: string;
};
type DayPreviewProps = {
  label: string;
  weather?: PreviewTile | "none";
  plans: readonly PreviewPlan[];
};
const words = copy.events.preview;
export function DayPreview({
  label,
  weather,
  plans
}: DayPreviewProps) {
  const heading = useId();
  return <aside aria-label={label} className="x13cq9vo x2lah0s x13o0s5z x2lwn1j x1odjw0f xish69e x9f619 x15fnm84 x78zum5 xdt5ytf x14n5cft xwe7p7i xh540kj">
      {weather === "none" && <p className="x1ghz6dp x19d36u7 x15i68ds xfrs9s4 x1fzhlzt">{words.noForecast}</p>}
      {weather && weather !== "none" && <WeatherTile {...weather} />}
      <div className="x78zum5 xdt5ytf x1c1vhfx">
        <Eyebrow>
          <span id={heading}>{words.also(plans.length)}</span>
        </Eyebrow>
        {plans.length === 0 ? <p className="x1ghz6dp x19d36u7 x15i68ds xfrs9s4 x1fzhlzt">{words.nothing}</p> : <ul aria-labelledby={heading} className="xe8uvvx x1ghz6dp x1717udv x78zum5 xdt5ytf x1665zp3">
            {plans.map(plan => <PlanRow key={plan.id} {...plan} />)}
          </ul>}
      </div>
    </aside>;
}
export function WeatherTile({
  icon,
  temp,
  condition,
  hours
}: PreviewTile) {
  return <div className="x78zum5 xdt5ytf xou54vl x1qhigcl xgqmno8 xc0ge15">
      <div className="x78zum5 x6s0dn4 xou54vl">
        <Icon icon={weatherIcons[icon]} size={40} strokeWidth={1.25} />
        <div className="x78zum5 xdt5ytf x1jnr06f xeuugli">
          <span className="x1tgwohi x1iikomf x75m3dq xo5v014">{temp}</span>
          <span className="x19d36u7 x15i68ds x1xfvgam">{condition}</span>
        </div>
      </div>
      {hours.length > 1 && <ul aria-label={words.hourly} className="xe8uvvx x1ghz6dp x1717udv xyamay9 xrvj5dj xamtbqh x167g77z x17xlhan">
          {hours.map(hour => <li key={hour.time} aria-label={hour.label} className="x78zum5 xdt5ytf x6s0dn4 x17d4w8g">
              <span className="xr0iwhn xhunfcg xt3et7w xtvhhri xuxw1ft">{hour.time}</span>
              <Icon icon={weatherIcons[hour.icon]} size={20} strokeWidth={1.5} />
              <span className="x1j61zf2 xo1l8bm">{hour.temp}</span>
            </li>)}
        </ul>}
    </div>;
}
export function PlanRow({
  time,
  title,
  who
}: PreviewPlan) {
  return <li className="x78zum5 xdt5ytf x17d4w8g xeuugli">
      <span className="xr0iwhn xhunfcg xt3et7w xtvhhri xuxw1ft">{time}</span>
      <span className="x19d36u7 x1xfvgam x1fzhlzt">
        <span className="xfbjfs5">{title}</span>
        {who && <span className="x15i68ds"> · {who}</span>}
      </span>
    </li>;
}